import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefreshinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "m2.247 7.5 2.891-2.892a5.5 5.5 0 0 1 3.89-1.61v0a5.5 5.5 0 0 1 5.106 3.457l.118.294"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "M5.248 7.5h-3V4.497M15.753 10.5l-2.891 2.892a5.5 5.5 0 0 1-3.89 1.61v0a5.5 5.5 0 0 1-5.106-3.457l-.118-.294"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "M12.752 10.5h3v3.002"
		})
	]
});
export default SvgRefreshinline;
